import { mapValues, get, isArray, forEach, set, isEmpty, isString, last, has } from 'lodash-es';
import { CUSTOM_ERROR_MESSAGES } from '~/app_constants';

export const mapFormFields = (base, fields, mutation = 'UPDATE_FIELD') => {
  return mapValues(fields, (path) => {
    return {
      get() {
        return get(this.$store.state[base], path);
      },
      set(val) {
        const value = val === undefined ? null : val;

        this.$store.commit(mutation, { path, value });
      },
    };
  });
};

export const formatErrors = (response, custom = '', errors = {}) => {
  response = custom ? setCustomErrors(response, custom) : response;

  forEach(response, (value, key) => {
    if (isArray(value)) {
      forEach(value, (valueVal, _valueKey) => {
        set(errors, [key], valueVal);
      });
    } else {
      set(errors, [key], value);
    }
  });

  return errors;
};

export const handleFormErrors = (form, errors, appMessage) => {
  if (!isEmpty(errors)) {
    forEach(errors, (errorValue, errorKey) => {
      if (errorKey === 'base') {
        appMessage(errorValue);
      } else if (isString(errorValue)) {
        form.setErrors({ [errorKey]: errorValue });
      } else {
        form.setErrors(errorValue);
      }
    });
  } else {
    appMessage('Unexpected error. Please try again.');
  }
};

export const setPayOptions = (constOptions, notExternal, customText) => {
  if (notExternal) {
    return constOptions;
  }
  const newId = (parseInt(last(constOptions).id) + 1).toString();

  return constOptions.concat({ id: newId, text: customText });
};

export const setCustomErrors = (data, resource) => {
  const customMessages = CUSTOM_ERROR_MESSAGES[resource];

  return mapValues(data, (messages, key) => {
    if (has(customMessages, key)) {
      return messages.map((msg) =>
        get(
          customMessages[key].find((replaceObj) => replaceObj[msg]),
          msg,
          msg,
        ),
      );
    }

    return messages;
  });
};
